import en from './locale/en';
import * as yup from 'yup';

yup.setLocale(en);
